// Keeps --page-scrollbar on <html> equal to the page scrollbar's width, measured while the page can scroll.
// eval-figma.css pads <html> by it while a modal locks the page, so hiding the scrollbar never moves the content.
export function trackPageScrollbar() {
  const html = document.documentElement;
  const measure = () => {
    // only measure while the page is not locked (a locked page has no scrollbar to measure)
    if (getComputedStyle(html).overflowY === "hidden") return;
    const width = Math.max(0, window.innerWidth - html.clientWidth);
    html.style.setProperty("--page-scrollbar", `${width}px`);
  };
  measure();
  window.addEventListener("resize", measure);
  // page height changes (content loads, routes) can add or remove the scrollbar
  if (window.ResizeObserver) new ResizeObserver(measure).observe(document.body);
}
